export default __webpack_public_path__ + "static/media/clutch_top_augmentation.7af68c20.png";